import React from 'react';

import './App.css';
import Giphy from './page/Giphy/Giphy';

function App() {
  return (
    <div className="App">
      <Giphy/>
    </div>
  );
}

export default App;
